
import { useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import { orderStore } from '@/stores/quick-order';
import { useGlobalStore } from '@/hooks';
import { storageHelper } from '@/utils';
import useRouterWithStylePath from '@/hooks/useRouterWithStylePath';

export interface UseStoreOptions {
  autoSelect?: boolean;
}

function extractPath(url: string) {
  const questionMarkIndex = url.indexOf('?');  // 查找查询参数开始的位置
  if (questionMarkIndex !== -1) {
    return url.substring(0, questionMarkIndex);  // 如果存在查询参数，剪切从开始到查询参数开始的部分
  }
  return url;  // 如果没有查询参数，直接返回整个字符串
}

const useStore = (options?: UseStoreOptions) => {

  const { autoSelect = true } = options??{};

  const storageBaseName = '__store_id';

  const { appConfig } = useGlobalStore();
  
  const router = useRouterWithStylePath();
  const { query, asPath } = router;
  const { updateState } = orderStore;

  const getDomainForStoreId = () => {

    const domainList = appConfig.domainList || [];
    const domain = appConfig.domain;

    if (router?.query.stylePath && appConfig?.isPebllaDomain && appConfig?.stylePath && domainList && domainList?.[0]?.shopId) {
      return domainList?.[0]?.shopId;
    }

    if (domainList) {
      const thisDomain = domainList?.find((item: any) => item.domain === domain);
      return thisDomain?.shopId;
    }
  }

  const getOrderPath = () => {
    if (appConfig?.isPebllaDomain && appConfig?.stylePath) {
      return `/${appConfig?.stylePath}/order`;
    }
    return '/order';
  }

  const asyncStoreId = () => {
    const sid = query.sid;
    const isPureDigital = typeof sid === 'string' ? /^[0-9]+$/.test(sid) : false;
    const storageStoreId = storageHelper.getItem(storageBaseName);
    const defaultStoreId = appConfig?.defaultStoreId;
    const domainStoreId = getDomainForStoreId();
    
    const storeId = (extractPath(asPath) === (getOrderPath()) && sid && isPureDigital) ? sid : storageStoreId || domainStoreId || defaultStoreId;
    storageHelper.setItem(storageBaseName, storeId);
  };

  const getStoreId = () => {
    asyncStoreId();
    return storageHelper.getItem(storageBaseName);
  }

  const [storeId, setStoreId] = useState(getStoreId());

  useEffect(() => {
    if (!storeId && autoSelect) {
      router.push('/store');
    }
  }, [storeId])

  const set = (id: string) => {
    if (id) {
      storageHelper.setItem('__store_id', id);
      setStoreId(storeId);
    }
  }

  const selectStore = (id: any, type: 'push' | 'reload' = 'push') => {
  
    if(storeId !== id) {
      // updateState({ cartList: [] }); 购物车保留
    }
    set(id);
    if (type === 'push') {
      router.push('/order');
    } else {
      router.reload();
    }
   
  } 
  
  return {
    storeId,
    selectStore,
    set
  }

}

export default useStore;